import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export function AdvertiseFAQ({ items, title = 'Frequently asked questions' }) {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h2 className="reveal font-display text-center text-2xl font-semibold text-slate-900 sm:text-3xl">{title}</h2>
      <Accordion type="single" collapsible className="reveal mt-8">
        {items.map(([q, a], i) => (
          <AccordionItem key={q} value={`item-${i}`}>
            <AccordionTrigger className="text-left font-medium text-slate-900">{q}</AccordionTrigger>
            <AccordionContent className="text-slate-600">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
